import { render } from "./registerSponsorAccount.vue?vue&type=template&id=3247a37a"
import script from "./registerSponsorAccount.vue?vue&type=script&lang=js"
export * from "./registerSponsorAccount.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__